import { gsap, ScrollTrigger } from '../LibrariesImport';
import { GlobalVariables } from '../GlobalVariables';

export default class BlockMilestones {
	static init() {
		this.blocks = document.querySelectorAll(".block-milestones");

		if (!this.blocks) {
			return;
		}

		this.mm = gsap.matchMedia();

		this.mm.add('(min-width: 768px) and (pointer: fine)', () => {
			this.pinWrapWidth = 0;
			this.horizontalScrollLength = 0;

			this.initHorizontalScroll();

			GlobalVariables.resizeCallbacks.push(this);
		});

		this.mm.add('(max-width: 768px) or (pointer: coarse)', () => this.initSlider());
	}

	static initHorizontalScroll() {
		this.blocks.forEach((block) => {
			const milestonesWrapper = block.querySelector('.milestones-wrapper');

			// calculer la largeur du container de chiffres clés
			this.resize();

			// Pin du block & scroll horizontal
			gsap.to(milestonesWrapper, {
				scrollTrigger: {
					scrub: true,
					trigger: block,
					pin: block,
					anticipatePin: 1,
					start: 'top 10%',
					end: () => `+=${this.pinWrapWidth} center`,
					invalidateOnRefresh: true,
					once: false,
				},
				x: () => -this.horizontalScrollLength,
				ease: 'none',
			});

			ScrollTrigger.addEventListener('refreshInit', () => this.resize());
		});
	}

	static resize() {
		this.blocks.forEach((block) => {
			const pinWrap = block.querySelector('.milestones-container');
			const blockPadding = parseFloat(getComputedStyle(block).getPropertyValue('padding-right'));

			this.pinWrapWidth = pinWrap.scrollWidth + blockPadding;
			this.horizontalScrollLength = this.pinWrapWidth + blockPadding - innerWidth;
		});
	}

	static initSlider() {
		this.blocks.forEach((block) => {
			const swiperContainer = block.querySelector('.milestones-container');
			const scrollbar = block.querySelector('.milestones-progress');

			const slider = new Swiper(swiperContainer, {
				loop: false,
				grabCursor: true,
				slidesPerView: 'auto',
				spaceBetween: '10px',
				speed: 500,
				touchEventsTarget: 'container',
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				scrollbar: {
					el: scrollbar,
					draggable: true,
					snapOnRelease: false,
				},
				on: {
					lock: () => {
						swiperContainer.classList.remove('swiper-is-active');
					},
					unlock: () => {
						swiperContainer.classList.add('swiper-is-active');
					},
					resize: (swiper) => {
						swiperContainer.classList.toggle('hidden', swiper.isEnd);
					},
				},
			});
		});
	}
}